import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { IShimmerStyles, Shimmer as FluentUiShimmer } from '@fluentui/react';

import { IShimmerProps } from './Shimmer.Props';
import { getShimmerStyles } from './Shimmer.styles';

export const Shimmer = (props: IShimmerProps) => {
  const { styles, fullWidth = false, ...otherProps } = props;

  return <FluentUiShimmer {...otherProps} styles={getShimmerStyles(styles as IShimmerStyles | undefined, fullWidth)} />;
};
